import { type Servicepoint, useFetchMultipleServicepoints } from '@dhl/receiver-servicepoint'

import { getTopLevelDomain } from '~/config/index.js'

type Args = {
  servicePointId?: string
  postalCode?: string
}

export type ServicepointTypeKey = 'locker' | 'servicepoint'

type Result = {
  servicepoint: Servicepoint | undefined
  isLoading: boolean
  typeKey: ServicepointTypeKey
}

export const useGetServicepointDetails = ({ servicePointId, postalCode }: Args): Result => {
  const countryCode = getTopLevelDomain().toUpperCase()

  const { data, isLoading } = useFetchMultipleServicepoints(
    {
      countryCode,
      servicePointIds: [servicePointId!],
      postalCode: postalCode!,
    },
    {
      query: {
        enabled: !!servicePointId && !!postalCode,
      },
    }
  )

  const servicepoint = data?.[0]

  return {
    servicepoint,
    isLoading,
    typeKey: servicepoint?.isLocker ? 'locker' : 'servicepoint',
  }
}
